<app-categories-table categoryType="Fabric" />
